import { render, staticRenderFns } from "./Jessibuca.vue?vue&type=template&id=c2f63eb0"
import script from "./Jessibuca.vue?vue&type=script&lang=js"
export * from "./Jessibuca.vue?vue&type=script&lang=js"
import style0 from "./Jessibuca.vue?vue&type=style&index=0&id=c2f63eb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports